import React from 'react';
import {
    Show,
    SimpleShowLayout,
    TextField,
    DateField,
    ReferenceField,
    FileField
} from 'react-admin';

export const AdminCompaniesHouseFilingHistoryShow = () => {

    return (
        <Show>
            <SimpleShowLayout>
                <DateField source="date"/>
                <TextField source="type"  />
                <TextField source="description"  />
                <ReferenceField
                    label="Companies House For"
                    source="companiesHouse"
                    reference="companies_house"
                >
                    <TextField source="companyName"/>
                </ReferenceField>
                <FileField source="viewPdf" title="Pdf" target="_blank" />
            </SimpleShowLayout>
        </Show>
    );
}